import { render, staticRenderFns } from "./DecisionDetails.vue?vue&type=template&id=147ed96c&scoped=true"
import script from "./DecisionDetails.vue?vue&type=script&lang=js"
export * from "./DecisionDetails.vue?vue&type=script&lang=js"
import style0 from "./DecisionDetails.vue?vue&type=style&index=0&id=147ed96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ed96c",
  null
  
)

export default component.exports